import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "tilde_svg__Iconï½System, Social" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "tilde_svg__Vector 6",
    d: "M5 12.8L6.87113 11.3031C7.85032 10.5197 9.21343 10.4281 10.2887 11.0732L13.7113 13.1268C14.7866 13.7719 16.1497 13.6803 17.1289 12.8969L19 11.4",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }